import React from 'react';


const Letra = ({ id, letra, jugarLetra, color }) => {
  const letraStyle = {
    backgroundColor: `#${color}`,
  }
  return (
    <button className="letra-btn" style={ letraStyle } onClick={ () => jugarLetra(letra, id) } >{ letra }</button>
  )
}

export default Letra